import { render, staticRenderFns } from "./NoResults.vue?vue&type=template&id=ad14ddbc&scoped=true&"
import script from "./NoResults.vue?vue&type=script&lang=js&"
export * from "./NoResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad14ddbc",
  null
  
)

export default component.exports